<template lang="pug">
div.fil-box
  template(v-if="!showMobile")
    topbar
    .conbox
      .hometabs
        tabList
  .tabbox
    .gbox-wrap.epic.aaa
      hotGame
  footerInfo
</template>
<script>
import topbar from '@/views/default/_topBar.vue'
import tabList from '@/views/default/_tabs.vue'
import footerInfo from '@/views/default/_footer.vue'
import hotGame from '@/component/slot/_hotgame.vue'
import config from "@/config";
export default {
  components:{
    topbar,
    tabList,
    footerInfo,
    hotGame
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      showMobile: false,
			imgUrl: config.imageUrl,
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    // getAnnBefore() {
    //   return this.$store.state.user.annBeforeLog
    // },
  },
  created(){
    $('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}`);
    this.checkSize()
  },
  mounted(){
    var vm = this
    $(window).resize(function () {
      vm.checkSize()
    });
  },
  methods:{
    checkSize(){
      if ($(window).width() < 681) {
        this.showMobile = true
      }else{
        this.showMobile = false
      }
    },
  }
}
</script>